import styled from 'styled-components';

export const StyledBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(3px);
  z-index: 10;
`;

export const StyledModalContainer = styled.div`
  width: 700px;
  max-height: 75vh;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${({ theme }) => theme.color('#FFFFFF')};
  border-radius: 4px;
  z-index: 11;
`;

export const StyledTitle = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #d5d5d5;
  width: 100%;
  justify-content: space-between;
`;

export const StyledContentContainer = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const StyledHardwareNav = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledHardwareNavItem = styled.button<{ active?: boolean }>`
  display: flex;
  width: 165px;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  background: ${({ active }) =>
    active ? 'rgba(0, 0, 0, 0.06)' : 'transparent'};
  border: none;
  border-right: 2px solid
    ${({ active }) => (active ? '#1B1A1F' : 'transparent')};
  padding-inline: 16px;
  padding-block: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    background: rgba(0, 0, 0, 0.06);
  }
`;

export const StyledContent = styled.div`
  padding: 16px;
  overflow-y: auto;
  min-height: 0;
`;

export const StyledGridContainer = styled.div<{ columns: number }>`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, auto) 16px;
  gap: 8px;
`;
